import { z } from 'zod';

export const CustomChargeSchema = z.object({
  id: z.string().uuid(),
  area_id: z.string().uuid(),
  description: z.string(),
  quantity: z.number().default(1),
  unit_cost: z.number().default(0),
  category: z.string().default('Miscellaneous'),
  notes: z.string().nullable(),
});

export const CreateCustomChargeSchema = z.object({
  area_id: z.string().uuid(),
  description: z.string().min(1, 'Description is required'),
  quantity: z.number().default(1),
  unit_cost: z.number().default(0),
  category: z.string().default('Miscellaneous'),
  notes: z.string().nullable().optional(),
});

export const UpdateCustomChargeSchema = CreateCustomChargeSchema.partial();

export type CustomCharge = z.infer<typeof CustomChargeSchema>;
export type CreateCustomCharge = z.infer<typeof CreateCustomChargeSchema>;
export type UpdateCustomCharge = z.infer<typeof UpdateCustomChargeSchema>;
